
/**
 * Module dependencies.
 */

import { keyframes as keyframesStyledComponents } from 'styled-components';

/**
 * `modalFadeInUp` keyframes.
 */

const modalFadeInUp = keyframesStyledComponents`
  from {
    opacity: 0;
    transform: translate3d(0, 16px, 0);
  }

  25% {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

/**
 * `fadeInDown` keyframes.
 */

const fadeInDown = keyframesStyledComponents`
  from {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;

/**
 * `fadeIn` keyframes.
 */

const fadeIn = keyframesStyledComponents`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

/**
 * `fadeOut` keyframes.
 */

const fadeOut = keyframesStyledComponents`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
`;

/**
 * `pulse` keyframes.
 */

const pulse = keyframesStyledComponents`
  from {
    transform: scale(0.4);
  }

  to {
    transform: scale(1);
  }
`;

/**
 * Export `keyframes`.
 */

export const keyframes = {
  fadeIn,
  fadeInDown,
  fadeOut,
  modalFadeInUp,
  pulse
};
